import { FC, useContext } from "react";

import * as cols from "components/ListingTable/setupColumns";
import { BaseListings } from "containers";
import { AppContext } from "contexts";
import * as routes from "routes";

import {
  makeDefaultUiParams,
  validDynamicRestUrlParams,
  validUiSortOptions,
} from "./filters/constants";
import { buildFilters } from "./filters";

const MyListings: FC = () => {
  const { user } = useContext(AppContext);
  const userId = user?.userId;

  return (
    <BaseListings
      buildFilters={buildFilters}
      makeDefaultUiParams={makeDefaultUiParams}
      validDynamicRestUrlParams={validDynamicRestUrlParams}
      validUiSortOptions={validUiSortOptions}
      desktopColumns={cols.desktopMyListings}
      mobileColumns={cols.mobileMyListings}
      headerContent={{
        h1Content: { default: "The Exchange" },
        subtitle1Content:
          "See your returns and offers here. For new assets now available for purchase, click the link below.",
        headerButtonContent: {
          label: "Open Listings",
          path: routes.orderBookOpenListings(userId),
        },
      }}
      title="My Listings"
      baseUrl={routes.orderBookMyListingsNoParams()}
    />
  );
};

export default MyListings;
